import { render, staticRenderFns } from "./PurchasedItemBase.vue?vue&type=template&id=3a3f1c12&scoped=true&"
import script from "./PurchasedItemBase.vue?vue&type=script&lang=ts&"
export * from "./PurchasedItemBase.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasedItemBase.vue?vue&type=style&index=0&id=3a3f1c12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f1c12",
  null
  
)

export default component.exports